import { render, staticRenderFns } from "./ViewPoint.vue?vue&type=template&id=1fa3802a&"
import script from "./ViewPoint.vue?vue&type=script&lang=js&"
export * from "./ViewPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports